export const stringReplaceAll = (target: string, search: string, replacement: string): string =>
  target.replace(new RegExp(search, 'g'), replacement)

const stringReverse = (string: string): string => string.split('').reverse().join('')

export const stringReplaceLast = (target: string, what: string, replacement: string): string =>
  stringReverse(stringReverse(target).replace(new RegExp(stringReverse(what)), stringReverse(replacement)))
